import React from 'react';
import { Dropdown, Grid, Input, Button, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { S3_BASE_URL } from '../../config/API';

const imageTypeOption = [
  {
    value: 'screensaver',
    text: 'Screensaver'
  },
  {
    value: 'banner',
    text: 'Banner'
  }
];


function CreateScreensaverComponent({
  imagePath,
  imageDescription,
  imageType,
  VmTypeId,
  imageLoaded,
  ScreensaverUrl,
  VmTypeOption,
  onChangeOnImagePath,
  onChangeOnImageDescription,
  onChangeOnImageType,
  onChangeOnVmTypeId,
  onClickOnSave,
  onImageLoad,
}) {
  return (
    <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title>Update Image </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4} textAlign="center">
          <h2
            style={{
                fontWeight: 400,
                border: '1px solid #555',
                textAlign: 'center',
                color: '#555',
                padding: '0.5em'
              }}
          >
            Update Image
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={6}>
          <Form >
            <Form.Field required >
              <label>Image Path</label>
              <Input
                placeholder="Example: daalchini.png"
                value={imagePath}
                onChange={onChangeOnImagePath}
              />
            </Form.Field>
            <Form.Field required >
              <label>Image Type</label>
              <Dropdown
                placeholder="Image Types"
                fluid
                selection
                value={imageType}
                options={imageTypeOption}
                onChange={onChangeOnImageType}
              />
            </Form.Field>
            <Form.Field required>
              <label>Image Description</label>
              <Input
                value={imageDescription}
                placeholder="Image Description"
                onChange={onChangeOnImageDescription}
              />
            </Form.Field>
            <Form.Field required >
              <label>Select VM Type</label>
              <Dropdown
                placeholder="VM Types"
                fluid
                selection
                value={VmTypeId}
                options={VmTypeOption}
                onChange={onChangeOnVmTypeId}
              />
            </Form.Field>
            <Button
              basic
              floated="right"
              color="blue"
              onClick={onClickOnSave}
            >
                  Update Image
            </Button>
          </Form>
        </Grid.Column>
        <Grid.Column width={2} >
          <Form>
            <Form.Field required>
              <label> Image </label>
              {!imageLoaded && imagePath && imageType ?
                <Form.Field >
                  <span style={{ color: 'red' }} > Image Not Found!!</span> <br/>
                  <span style={{ color: 'red', fontSize: '12px' }} > Try to change Image Path or Image Type </span>
                </Form.Field> : null
              }
              <img
                src={`${S3_BASE_URL}/${ScreensaverUrl}`}
                alt=""
                style={{ height: '30vh' }}
                onLoad={onImageLoad}
              />
            </Form.Field>
          </Form>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default CreateScreensaverComponent;



// WEBPACK FOOTER //
// ./src/Modules/UpdateImage/component.jsx